import { useSelector } from 'react-redux'
import { selectors } from 'client/reducers/blocksReducer'

export default function useBlocks(selector) {
  return useSelector(state => selector(state.blocks))
}

export { selectors }
